import template from './jk-problem-message.jade';

export default angular.module('cian.addForm.jkProblemMessage', []).directive('cianAfAddressJkProblemMessage', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    'jkService',
    function (jkService) {
      this.jkService = jkService;
      this.hasProblems = jkService.hasProblems;
    },
  ],
  controllerAs: 'jkProblemMessage',
  template,
  replace: true,
})).name;
